export default __webpack_public_path__ + "static/media/population.25f74cff.svg";